import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from "@angular/router";
import { Observable, of, switchMap } from "rxjs";
import { AuthService } from "app/core/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class NoAuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private _authService: AuthService, private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._check(state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._check(state);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this._check();
  }

  /**
   * Private check logic
   */
  private _check(state?: RouterStateSnapshot): Observable<boolean> {
    return this._authService.check().pipe(
      switchMap((authenticated) => {
        if (authenticated) {
          // Extract programId and communityId from the URL query params (if present)
          const urlTree = this._router.parseUrl(state?.url || "");
          const programId = urlTree.queryParams["programId"];
          const communityId = urlTree.queryParams["communityId"];

          if (programId && communityId) {
            // ✅ Redirect to program-registration with params
            this._router.navigate(["/program-registration"], {
              queryParams: { programId, communityId },
            });
          } else {
            // Default: dashboard
            this._router.navigate(["/dashboard"]);
          }
          return of(false);
        }
        return of(true);
      })
    );
  }
}
